import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker, Range, RangeKeyDict } from 'react-date-range';
import { getRouteDates } from '../../actions/routes/routesThunks';
import { useDispatch } from 'react-redux';
import { dispatch_theme } from '../../config/colors';
import { i18next } from '../../config/i18n';
import { de as deDE, enGB } from 'date-fns/locale';
import routesApi from '../../apis/routesApi';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import { isBefore, isSameMonth, startOfMonth, set } from 'date-fns';
import { TLRange } from '../../config/types/Routes';
import { AppDispatch } from '../../index';

const langs: {[key: string]: any} = {
  de: deDE,
  en: enGB
};

Picker.propTypes = {
  onChange: PropTypes.func.isRequired,
  ranges: PropTypes.array.isRequired
};

const useStyles = makeStyles((theme: typeof dispatch_theme) => ({
  absolute: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(3)
  }
}));

export type PickerProps = {
  onChange: (date: RangeKeyDict) => void;
  ranges: TLRange[]
};

function Picker (props: PickerProps) {
  const { onChange, ranges } = props;

  const [state, setState] = useState<Range[]>(ranges);

  const [focus, setFocus] = useState<0 | 1>(0);
  const [busy, setBusy] = useState<Range[]>([]);

  const dispatch: AppDispatch = useDispatch();
  const onGetRouteDates = () => dispatch(getRouteDates());
  const [selected] = state;

  useEffect(() => {
    return () => {
      routesApi.abortFetch();
    };
  }, []);

  function checkBusy (date: Date) {
    const start = (selected && selected.startDate);
    const end = (selected && selected.endDate);
    const monthA = start.getMonth();
    const monthB = end.getMonth();
    const newMonth = date.getMonth();
    if (newMonth !== monthB || newMonth !== monthA) {
      getBusyDays(date);
      const fst = startOfMonth(new Date(date));
      const updatedSelection = {
        ...selected,
        endDate: isSameMonth(fst, new Date(selected.endDate))
          ? selected.endDate
          : fst
      };
      if (!isBefore(new Date(fst), new Date(selected.startDate))) {
        setState([updatedSelection]);
        setFocus(1);
        return;
      }
      setState([{
        ...selected,
        startDate: fst,
        endDate: fst
      }]);
      setFocus(0);
    }
  }

  function getBusyDays (date: Date, init: boolean = false) {
    onGetRouteDates()
      .then((route_days_per_month: number[]) => {
        const dayz = route_days_per_month
          .map(day => ({
            startDate: set(new Date(date), {date: day}),
            endDate: set(new Date(date), {date: day}),
            color: dispatch_theme.palette.secondary.main,
            key: 'selection',
            showDateDisplay: false
          }));
        setBusy(dayz);
      });
  }
  const both = [...state, ...busy];
  return (
    <Grid container justifyContent={'flex-end'} alignItems={'center'}>
      <Grid item xs={12}>
        <DateRangePicker
          locale={langs[i18next.language]}
          rangeColors={[dispatch_theme.palette.primary.main]}
          onChange={(newRange: RangeKeyDict) => {
            onChange(newRange);
            setState([newRange.selection]);
            setFocus(focus ? 0 : 1);
          }}
          ranges={both}
          focusedRange={[0, focus]}
          direction="horizontal"
          onShownDateChange={checkBusy}
        />
      </Grid>
    </Grid>
  );
}

export default Picker;
